import { TDistinctors } from '@apia/dom-store';
import { TCellDistinctions, TGridDistinctions, TState } from './types';

export const distinctors: TDistinctors<TState> = {
  grid: [
    (distinctors: TGridDistinctions, state) => {
      return {
        etc: {
          'aria-activedescendant':
            distinctors.iconsCount > 0
              ? `${state.storeId}__${state.focusedRow}__${state.focusedColumn}`
              : undefined,
          role: 'grid',
          'aria-rowcount': distinctors.rows,
          'aria-colcount': distinctors.columns,
          id: state.storeId,
        },
      };
    },
  ],
  cell: [
    (distinctions: TCellDistinctions, state) => {
      const isFocused =
        state.focusedColumn === distinctions.columnIndex &&
        state.focusedRow === distinctions.rowIndex;
      return {
        etc: {
          id: `${state.storeId}__${distinctions.rowIndex}__${distinctions.columnIndex}`,
        },
        classList: {
          add: isFocused ? ['focused'] : undefined,
          remove: isFocused ? undefined : ['focused'],
        },
      };
    },
    (_: TState, state: TState) => {
      const focusedCell = document.querySelector(
        `#${state.storeId} [aria-rowindex="${state.focusedRow}"] [aria-colindex="${state.focusedColumn}"]`,
      );

      focusedCell?.scrollIntoView({
        behavior: 'instant',
        block: 'nearest',
        inline: 'nearest',
      });
    },
  ],
};
